import { AxiosRequestConfig } from 'axios';

import { ApiClient } from '@/services/api/api-client';
import { paths } from '@/services/api/api.schema';
import type { InferApiErrorCodes } from '@/services/api/types/infer-api-error-codes';

export const getMyUser = async ({
  config,
}: {
  config?: AxiosRequestConfig;
}) => {
  const response = await ApiClient.get(`/v2/users/me`, {
    ...config,
  });
  return response.data;
};

export type User = GetMyUser;

type GetMyUser =
  paths['/v2/users/me']['get']['responses']['200']['content']['application/vnd.api+json'];

export type GetMyUserApiErrorCodes = InferApiErrorCodes<
  paths['/v2/users/me']['get']['responses']
>;
